const futura = '"futura-pt", arial, helvetica, sans-serif';
const futuraCondensed = '"futura-pt-condensed", impact, sans-serif';

export const bodyFont = futura;
export const headingFont = futuraCondensed;
